export const getReplacedString = (string = '') =>
  string
    .toLowerCase()
    .replace(/[-,\(\)\.\s]/g, '')
    .replaceAll('й', 'и')
    .replaceAll('ё', 'е');
